import React from 'react'
import { Pane, Select } from 'evergreen-ui'
export const Enum = ({ field }) => {
    return <Pane>
        <Select value={field.subtype} onChange={e => field.subtype = e.target.value}>
            <option value={false}>Wybierz</option>
            <option value="preset">Preset</option>
        </Select>
        {field.subtype && <Select value={field.preset} onChange={e => field.preset = e.target.value}>
            <option value={false}>Wybierz</option>
            <option value="icons">Ikony geometryczne</option>
            <option value="colors">Kolory</option>
        </Select>}
    </Pane>
} 